import React from 'react';
import {useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';

type SortableTaskItemProps = {
    children: React.ReactNode;
    id: string | number;
};

const SortableTaskItem = ({children, id}: SortableTaskItemProps) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({id});

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.3 : 1,
        filter: isDragging ? 'grayscale(1)' : '',
        zIndex: 1
    };

    return (
        <div ref={setNodeRef} style={style} {...attributes} {...listeners}
        >
            {children}
        </div>
    );
};

export default SortableTaskItem;
